import React from 'react';
import PropTypes from 'prop-types';
// import { DtpAccordionPanel, DtpAccordionGroup } from 'dtp-react-components';
// import ListaUoItem from './ListaUoItem';
import { Table } from '../index';

const ListaUos = (props) => {
  const linhasPorPagina = 10;

  const options = {
    noDataText: 'Nenhuma orgão local encontrado para o ente federativo',
    hideSizePerPage: true,
    sizePerPage: 10,
  };

  const tableHeader = [{
    id: 'idUoInss0',
    label: '',
  }, {
    id: 'idUoInss1',
    label: '',
  }, {
    id: 'idUoInss2',
    label: '',
  }];

  const montaListaFormatadaUos = () => {
    const colunasPorPagina = 3;
    let pagina = 0;
    let linha = 0;
    let coluna = 0;
    const listaFormatada = [];
    listaFormatada[0] = {};
    if (props.listaUosInss === undefined) {
      listaFormatada.length = 0;
    } else {
      props.listaUosInss.forEach((uo, index) => {
        listaFormatada[linha][`idUoInss${coluna}`] = uo.idUoInss;
        if ((index + 1) % linhasPorPagina === 0) {
          if ((index + 1) % (linhasPorPagina * colunasPorPagina) === 0) {
            pagina += 1;
            linha = pagina * linhasPorPagina;
            coluna = 0;
            if (listaFormatada[linha] === undefined) {
              listaFormatada[linha] = {};
            }
          } else {
            linha = pagina * linhasPorPagina;
            coluna += 1;
            if (coluna % colunasPorPagina === 0) {
              coluna = 0;
            }
          }
        } else {
          linha += 1;
          if (listaFormatada[linha] === undefined) {
            listaFormatada[linha] = {};
          }
        }
      });
    }

    return listaFormatada;
  };

  return props.listaUosInss.length > 0 ? (
    <Table
      bordered
      data={montaListaFormatadaUos()}
      options={options}
      listaTableHeader={tableHeader}
      pagination
      scrollTop="Top"
    />
  ) : null;
};

ListaUos.propTypes = {
  listaUosInss: PropTypes.arrayOf(PropTypes.shape({
    idParticipante: PropTypes.string,
    idUoInss: PropTypes.string,
  })).isRequired,
};

export default ListaUos;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/ListaUos.jsx